(function() {
  const botones_Tallas = document.querySelectorAll('input[data-name="Tallas"]')
  botones_Tallas.forEach(function (boton) {
    const variants = JSON.parse(boton.closest('variant-radios-card').querySelector('script').textContent)
    boton.addEventListener('click', function () {
      let Tallas
      Tallas = boton.closest('variant-radios-card').querySelector('input[data-name="Tallas"]:checked').value
      const variant = getVariantData(variants, [Tallas]);
      const submitButton = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.quick-add__submit')
      addToCart(variant, submitButton)
    })
  })
})()

function updateProductImagePrice (boton, producto) {
  const Tallas = boton.closest('variant-radios-card').querySelector('input[data-name="Tallas"]:checked').value
  const data = getVariantData(producto, [Tallas])
  // const image = data["featured_image"].replace("https:","");
  // cambiar imagen y precio del producto en la vista
  // const img = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.card__media img');
  const price = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.price__sale .price-item')
  const compared_at_price = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.price__sale .price-item--regular')
  const variant_price = data.price
  const variant_compared_at_price = data.compare_at_price
  // const current_src = img.getAttribute('src');
  // const current_width = current_src.split('&width=')[1];
  // img.srcset = "";
  /* if( image != ""){
    img.src = image+"&width="+current_width;
  } */
  price.innerHTML = Shopify.formatMoney(variant_price, '{{amount_with_comma_separator}} €')
  compared_at_price.innerHTML = Shopify.formatMoney(variant_compared_at_price, '{{amount_with_comma_separator}} €')
  if (!variant_compared_at_price) {
    compared_at_price.style.display = 'none'
  } else {
    compared_at_price.style.display = 'inline'
  }
}

function updateInit (boton, producto) {
  const Tallas = boton.closest('variant-radios-card').querySelector('input[data-name="Tallas"]:checked').value
  const data = getVariantData(producto, [Tallas])
  const price = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.price__sale .price-item')
  const compared_at_price = boton.closest('.grid__item, .row_ccu-carrousel').querySelector('.price__sale .price-item--regular')
  const variant_price = data.price
  const variant_compared_at_price = data.compare_at_price
  price.innerHTML = Shopify.formatMoney(variant_price, '{{amount_with_comma_separator}} €')
  compared_at_price.innerHTML = Shopify.formatMoney(variant_compared_at_price, '{{amount_with_comma_separator}} €')
  if (!variant_compared_at_price) {
    compared_at_price.style.display = 'none'
  } else {
    compared_at_price.style.display = 'inline'
  }
}

function cargarProducto (product_handle) {
  return new Promise((resolve, reject) => {
    fetch(window.Shopify.routes.root + 'products/' + product_handle + '.js').then(function (response) {
      resolve(response.json())
    }).catch(function (error) {
      reject(error)
    })
  })
}

// funcion para añadir ala cesta por ajax, cambiando los valores de id de variante en el form y pulsando el botón de añadir ala cesta
function addToCart (variant, submitButton) {
  const available = variant.available
  const variantInput = submitButton.closest('form').querySelector('input[name="id"]')
  variantInput.value = variant.id

  if (available === true) {
    submitButton.removeAttribute('disabled')
    submitButton.click()
  } else {
    submitButton.setAttribute('disabled', '')
  }
}

function getVariant (variants, options) {
  let selectedVariant = null

    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i]
      let match = false
      if (variant.option1 === options[0]) {
        match = true
      }
      if (match) {
        selectedVariant = variant
        break
      }
    }
  
  return selectedVariant
}

// funcion para obtener id de variante en base a las 2 opciones seleccionadas pasadas en el array options
function getVariantData (variants, options) {
  const variant = getVariant(variants, options)
  const data = []
  if (variant == null) return null
  data.compare_at_price = variant.compare_at_price
  data.price = variant.price
  data.featured_image = ''
  if (variant.featured_image !== '' && variant.featured_image != null) {
    data.featured_image = variant.featured_image.src
  } else {
    data.featured_image = ''
  }
  data.id = variant.id
  data.available = variant.available
  return data
}
